import firebase from "firebase";


const FirebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDmidSyImj9Zg-nal0S4FoVn1YUERyNV2o",
  authDomain: "modern-portfolio-6ac9c.firebaseapp.com",
  projectId: "modern-portfolio-6ac9c",
  storageBucket: "modern-portfolio-6ac9c.appspot.com",
  messagingSenderId: "876603690967",
  appId: "1:876603690967:web:9768e8598b61f037948592",
});

const db = FirebaseApp.firestore();
export {db} ;
